export const RetentionTypes = {
    MACHINE_PACKAGE_CACHE: "MachinePackageCache",
    LIFECYCLE_RETENTION: "LifecycleRetention",
    TENTACLE_RETENTION: "TentacleRetention",
    RUNBOOK_RETENTION: "RunbookRetention",
} as const;

export type RetentionType = (typeof RetentionTypes)[keyof typeof RetentionTypes];
